import { Radar } from 'react-chartjs-2';
import { registerCharts } from './chartSetup';
import { useChartTheme } from './useChartTheme';

registerCharts();

export interface CompositionRow {
  label: string;
  value: number; // contribution_to_overall, 0-100 scale
}

interface Props {
  rows: CompositionRow[];
}

export default function CompositionRadar({ rows }: Props) {
  const theme = useChartTheme();

  const data = {
    labels: rows.map((r) => r.label),
    datasets: [
      {
        label: 'Contribution',
        data: rows.map((r) => r.value),
        borderColor: theme.accent,
        backgroundColor: theme.accentDim,
        borderWidth: 2,
        pointBackgroundColor: theme.accent,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: {
      r: {
        grid: { color: theme.grid },
        angleLines: { color: theme.grid },
        pointLabels: { color: theme.text, font: { size: 11 } },
        ticks: { display: false, backdropColor: 'transparent' },
        suggestedMin: 0,
      },
    },
  };

  return (
    <div className="POST__ANALYSIS__chartcard">
      <Radar data={data} options={options} />
    </div>
  );
}
